import { render, staticRenderFns } from "./AddOrEditChannel.vue?vue&type=template&id=a1cd13d2&scoped=true"
import script from "./AddOrEditChannel.vue?vue&type=script&lang=js"
export * from "./AddOrEditChannel.vue?vue&type=script&lang=js"
import style0 from "./AddOrEditChannel.vue?vue&type=style&index=0&id=a1cd13d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1cd13d2",
  null
  
)

export default component.exports